export default [
  {
    path:'/logisticsquery',
    name:'logisticsquery',
    component:resolve=>require(['@/pages/my/logisticsquery'],resolve)
  },
  {
    path:'/my/orderlist',
    component:resolve=>require(['@/pages/my/order/list'],resolve)
  },
  {
    path:'/my/orderdetail',
    component:resolve=>require(['@/pages/my/order/detail'],resolve)
  },
]